// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IContributionAuditResponse } from './IContributionAuditResponse';
import {
    IContributionAuditResponseFromJSON,
    IContributionAuditResponseFromJSONTyped,
    IContributionAuditResponseToJSON,
    IContributionAuditResponseToJSONTyped,
} from './IContributionAuditResponse';

/**
 * 
 * @export
 * @interface ICustomPageContributionAuditResponse
 */
export interface ICustomPageContributionAuditResponse {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContributionAuditResponse
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContributionAuditResponse
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContributionAuditResponse
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContributionAuditResponse
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageContributionAuditResponse
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IContributionAuditResponse>}
     * @memberof ICustomPageContributionAuditResponse
     */
    content?: Array<IContributionAuditResponse>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageContributionAuditResponse
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContributionAuditResponse
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContributionAuditResponse
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageContributionAuditResponse
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageContributionAuditResponse interface.
 */
export function instanceOfICustomPageContributionAuditResponse(value: object): value is ICustomPageContributionAuditResponse {
    return true;
}

export function ICustomPageContributionAuditResponseFromJSON(json: any): ICustomPageContributionAuditResponse {
    return ICustomPageContributionAuditResponseFromJSONTyped(json, false);
}

export function ICustomPageContributionAuditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageContributionAuditResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IContributionAuditResponseFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageContributionAuditResponseToJSON(json: any): ICustomPageContributionAuditResponse {
    return ICustomPageContributionAuditResponseToJSONTyped(json, false);
}

export function ICustomPageContributionAuditResponseToJSONTyped(value?: ICustomPageContributionAuditResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IContributionAuditResponseToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

